/* Generated from gemoji. Do not edit manually. */
export const MARKDOWN_EMOJI_SHORTCODE_MAP: Readonly<Record<string, string>> = {
  '100': '💯',
  '911': '🚨',
  '1234': '🔢',
  '-1': '👎',
  '+1': '👍',
  '1st_place_medal': '🥇',
  '2nd_place_medal': '🥈',
  '3rd_place_medal': '🥉',
  '8ball': '🎱',
  a: '🅰️',
  ab: '🆎',
  abacus: '🧮',
  abc: '🔤',
  abcd: '🔡',
  accept: '🉑',
  accessibility: '♿',
  accordion: '🪗',
  achoo: '🤧',
  adhesive_bandage: '🩹',
  adult: '🧑',
  aerial_tramway: '🚡',
  afghanistan: '🇦🇫',
  airplane: '✈️',
  airport: '🛄',
  aland_islands: '🇦🇽',
  alarm_clock: '⏰',
  albania: '🇦🇱',
  alembic: '⚗️',
  algeria: '🇩🇿',
  alien: '👽',
  alphabet: '🔤',
  amazed: '😲',
  ambulance: '🚑',
  america: '🇺🇸',
  american_samoa: '🇦🇸',
  amphora: '🏺',
  anatomical_heart: '🫀',
  anchor: '⚓',
  andorra: '🇦🇩',
  angel: '👼',
  anger: '💢',
  angola: '🇦🇴',
  angry: '💢',
  anguilla: '🇦🇮',
  anguished: '😧',
  announcement: '📢',
  annoyed: '😠',
  ant: '🐜',
  antarctica: '🇦🇶',
  antigua_barbuda: '🇦🇬',
  applause: '👏',
  apple: '🍎',
  approve: '👍',
  aquarius: '♒',
  archery: '🏹',
  argentina: '🇦🇷',
  aries: '♈',
  armenia: '🇦🇲',
  arrow_backward: '◀️',
  arrow_double_down: '⏬',
  arrow_double_up: '⏫',
  arrow_down: '⬇️',
  arrow_down_small: '🔽',
  arrow_forward: '▶️',
  arrow_heading_down: '⤵️',
  arrow_heading_up: '⤴️',
  arrow_left: '⬅️',
  arrow_lower_left: '↙️',
  arrow_lower_right: '↘️',
  arrow_right: '➡️',
  arrow_right_hook: '↪️',
  arrow_up: '⬆️',
  arrow_up_down: '↕️',
  arrow_up_small: '🔼',
  arrow_upper_left: '↖️',
  arrow_upper_right: '↗️',
  arrows_clockwise: '🔃',
  arrows_counterclockwise: '🔄',
  art: '🎨',
  articulated_lorry: '🚛',
  artificial_satellite: '🛰️',
  artist: '🧑‍🎨',
  aruba: '🇦🇼',
  ascension_island: '🇦🇨',
  asterisk: '*️⃣',
  astonished: '😲',
  astronaut: '🧑‍🚀',
  athletic_shoe: '👟',
  atm: '🏧',
  atom_symbol: '⚛️',
  attack: '👊',
  aubergine: '🍆',
  australia: '🇦🇺',
  austria: '🇦🇹',
  auto_rickshaw: '🛺',
  autumn: '🍂',
  avocado: '🥑',
  award: '🏆',
  axe: '🪓',
  azerbaijan: '🇦🇿',
  b: '🅱️',
  baby: '👶',
  baby_bottle: '🍼',
  baby_chick: '🐤',
  baby_symbol: '🚼',
  back: '🔙',
  bacon: '🥓',
  badger: '🦡',
  badminton: '🏸',
  bag: '👝',
  bagel: '🥯',
  baggage_claim: '🛄',
  bags: '🛍️',
  baguette_bread: '🥖',
  bahamas: '🇧🇸',
  bahrain: '🇧🇭',
  balance_scale: '⚖️',
  bald_man: '👨‍🦲',
  bald_woman: '👩‍🦲',
  ballet_shoes: '🩰',
  balloon: '🎈',
  ballot_box: '🗳️',
  ballot_box_with_check: '☑️',
  bamboo: '🎍',
  banana: '🍌',
  bang: '❗',
  bangbang: '‼️',
  bangladesh: '🇧🇩',
  banjo: '🪕',
  bank: '🏦',
  bar_chart: '📊',
  barbados: '🇧🇧',
  barber: '💈',
  barf: '🤮',
  baseball: '⚾',
  basket: '🧺',
  basketball: '🏀',
  basketball_man: '⛹️‍♂️',
  basketball_woman: '⛹️‍♀️',
  bat: '🦇',
  bath: '🚿',
  bathtub: '🛁',
  battery: '🔋',
  bawling: '😭',
  beach: '👙',
  beach_umbrella: '⛱️',
  beans: '🫘',
  bear: '🐻',
  bearded_person: '🧔',
  beauty: '💇',
  beaver: '🦫',
  bed: '🛏️',
  bee: '🐝',
  beer: '🍺',
  beers: '🍻',
  beetle: '🪲',
  beginner: '🔰',
  belarus: '🇧🇾',
  belgium: '🇧🇪',
  belize: '🇧🇿',
  bell: '🔔',
  bell_pepper: '🫑',
  bellhop_bell: '🛎️',
  benin: '🇧🇯',
  bento: '🍱',
  bermuda: '🇧🇲',
  beverage_box: '🧃',
  bhutan: '🇧🇹',
  bicep: '💪',
  bicycle: '🚲',
  bicyclist: '🚴',
  bike: '🚲',
  biking_man: '🚴‍♂️',
  biking_woman: '🚴‍♀️',
  bikini: '👙',
  billed_cap: '🧢',
  billiards: '🎱',
  biohazard: '☣️',
  bird: '🐦',
  birthday: '🎁',
  bison: '🦬',
  biting_lip: '🫦',
  black_bird: '🐦‍⬛',
  black_cat: '🐈‍⬛',
  black_circle: '⚫',
  black_flag: '🏴',
  black_heart: '🖤',
  black_joker: '🃏',
  black_large_square: '⬛',
  black_medium_small_square: '◾',
  black_medium_square: '◼️',
  black_nib: '✒️',
  black_small_square: '▪️',
  black_square_button: '🔲',
  blind: '🙈',
  block: '🚫',
  blond_haired_man: '👱‍♂️',
  blond_haired_person: '👱',
  blond_haired_woman: '👱‍♀️',
  blonde_woman: '👱‍♀️',
  blossom: '🌼',
  blow: '💨',
  blowfish: '🐡',
  blown: '🤯',
  blue_book: '📘',
  blue_car: '🚙',
  blue_heart: '💙',
  blue_square: '🟦',
  blueberries: '🫐',
  blush: '☺️',
  boar: '🐗',
  boat: '⛵',
  bolivia: '🇧🇴',
  bomb: '💣',
  bone: '🦴',
  book: '📖',
  bookmark: '🔖',
  bookmark_tabs: '📑',
  books: '📚',
  boom: '💣',
  boomerang: '🪃',
  boot: '👢',
  bosnia_herzegovina: '🇧🇦',
  botswana: '🇧🇼',
  bottle: '🍾',
  bouldering: '🧗‍♀️',
  bouncing_ball_man: '⛹️‍♂️',
  bouncing_ball_person: '⛹️',
  bouncing_ball_woman: '⛹️‍♀️',
  bouquet: '💐',
  bouvet_island: '🇧🇻',
  bow: '🙇',
  bow_and_arrow: '🏹',
  bowing_man: '🙇‍♂️',
  bowing_woman: '🙇‍♀️',
  bowl_with_spoon: '🥣',
  bowling: '🎳',
  boxing_glove: '🥊',
  boy: '👦',
  brain: '🧠',
  brazil: '🇧🇷',
  bread: '🍞',
  breakfast: '🍵',
  breast_feeding: '🤱',
  bricks: '🧱',
  bride_with_veil: '👰‍♀️',
  bridge_at_night: '🌉',
  briefcase: '💼',
  british: '🇬🇧',
  british_indian_ocean_territory: '🇮🇴',
  british_virgin_islands: '🇻🇬',
  broccoli: '🥦',
  broken_heart: '💔',
  bronze: '🥉',
  broom: '🧹',
  brown_circle: '🟤',
  brown_heart: '🤎',
  brown_square: '🟫',
  brunei: '🇧🇳',
  bubble_tea: '🧋',
  bubbles: '🫧',
  bubbly: '🍾',
  bucket: '🪣',
  bug: '🐞',
  building_construction: '🏗️',
  bulb: '💡',
  bulgaria: '🇧🇬',
  bullettrain_front: '🚅',
  bullettrain_side: '🚄',
  bunny: '🐰',
  burger: '🍔',
  burkina_faso: '🇧🇫',
  burma: '🇲🇲',
  burn: '🔥',
  burrito: '🌯',
  burundi: '🇧🇮',
  bury: '👎',
  bus: '🚌',
  business: '💼',
  business_suit_levitating: '🕴️',
  busstop: '🚏',
  bust_in_silhouette: '👤',
  busts_in_silhouette: '👥',
  butter: '🧈',
  butterfly: '🦋',
  cactus: '🌵',
  cafe: '☕',
  cake: '🍰',
  calendar: '📆',
  call: '📞',
  call_me_hand: '🤙',
  calling: '📲',
  cambodia: '🇰🇭',
  camel: '🐫',
  camera: '📷',
  camera_flash: '📸',
  cameroon: '🇨🇲',
  camping: '⛺',
  canada: '🇨🇦',
  canary_islands: '🇮🇨',
  cancer: '♋',
  candle: '🕯️',
  candy: '🍬',
  canned_food: '🥫',
  canoe: '🛶',
  cape_verde: '🇨🇻',
  capital_abcd: '🔠',
  capricorn: '♑',
  car: '🚗',
  card_file_box: '🗃️',
  card_index: '📇',
  card_index_dividers: '🗂️',
  caribbean_netherlands: '🇧🇶',
  carousel_horse: '🎠',
  carpentry_saw: '🪚',
  carrot: '🥕',
  cartwheeling: '🤸',
  cat: '🐱',
  cat2: '🐈',
  cayman_islands: '🇰🇾',
  cd: '💿',
  celebration: '🎆',
  central_african_republic: '🇨🇫',
  ceuta_melilla: '🇪🇦',
  chad: '🇹🇩',
  chains: '⛓️',
  chair: '🪑',
  champagne: '🍾',
  chart: '💹',
  chart_with_downwards_trend: '📉',
  chart_with_upwards_trend: '📈',
  checkered_flag: '🏁',
  cheers: '🥂',
  cheese: '🧀',
  chef: '👩‍🍳',
  cherries: '🍒',
  cherry_blossom: '🌸',
  chess_pawn: '♟️',
  chestnut: '🌰',
  chicken: '🍗',
  child: '👪',
  children_crossing: '🚸',
  chile: '🇨🇱',
  china: '🇨🇳',
  chipmunk: '🐿️',
  chocolate_bar: '🍫',
  chocolates: '💝',
  chop: '🔪',
  chopsticks: '🥢',
  christmas: '🎁',
  christmas_island: '🇨🇽',
  christmas_tree: '🎄',
  church: '⛪',
  cigarette: '🚬',
  cinema: '🎦',
  circus_tent: '🎪',
  city_sunrise: '🌇',
  city_sunset: '🌆',
  cityscape: '🏙️',
  cl: '🆑',
  clamp: '🗜️',
  clap: '👏',
  clapper: '🎬',
  classical_building: '🏛️',
  classy: '🎩',
  climbing: '🧗',
  climbing_man: '🧗‍♂️',
  climbing_woman: '🧗‍♀️',
  clinking_glasses: '🥂',
  clipboard: '📋',
  clipperton_island: '🇨🇵',
  clock1: '🕐',
  clock10: '🕙',
  clock1030: '🕥',
  clock11: '🕚',
  clock1130: '🕦',
  clock12: '🕛',
  clock1230: '🕧',
  clock130: '🕜',
  clock2: '🕑',
  clock230: '🕝',
  clock3: '🕒',
  clock330: '🕞',
  clock4: '🕓',
  clock430: '🕟',
  clock5: '🕔',
  clock530: '🕠',
  clock6: '🕕',
  clock630: '🕡',
  clock7: '🕖',
  clock730: '🕢',
  clock8: '🕗',
  clock830: '🕣',
  clock9: '🕘',
  clock930: '🕤',
  closed_book: '📕',
  closed_lock_with_key: '🔐',
  closed_umbrella: '🌂',
  cloud: '⛅',
  cloud_with_lightning: '🌩️',
  cloud_with_lightning_and_rain: '⛈️',
  cloud_with_rain: '🌧️',
  cloud_with_snow: '🌨️',
  clown_face: '🤡',
  clubs: '♣️',
  cn: '🇨🇳',
  coat: '🧥',
  cockroach: '🪳',
  cocktail: '🍸',
  coconut: '🥥',
  cocos_islands: '🇨🇨',
  coder: '👩‍💻',
  coffee: '☕',
  coffin: '⚰️',
  coin: '🪙',
  cold: '❄️',
  cold_face: '🥶',
  cold_sweat: '😰',
  college: '🎓',
  collision: '💥',
  colombia: '🇨🇴',
  comet: '☄️',
  comment: '💬',
  comoros: '🇰🇲',
  compass: '🧭',
  computer: '💻',
  computer_mouse: '🖱️',
  confetti_ball: '🎊',
  confounded: '😖',
  confused: '❓',
  congo_brazzaville: '🇨🇬',
  congo_kinshasa: '🇨🇩',
  congratulations: '㊗️',
  console: '🎮',
  construction: '🚧',
  construction_worker: '👷',
  construction_worker_man: '👷‍♂️',
  construction_worker_woman: '👷‍♀️',
  contest: '🏆',
  control_knobs: '🎛️',
  controller: '🎮',
  convenience_store: '🏪',
  cook: '🧑‍🍳',
  cook_islands: '🇨🇰',
  cookie: '🍪',
  cool: '🆒',
  cop: '👮‍♀️',
  copyright: '©️',
  coral: '🪸',
  corn: '🌽',
  costa_rica: '🇨🇷',
  cote_divoire: '🇨🇮',
  couch_and_lamp: '🛋️',
  couple: '👬',
  couple_with_heart: '💑',
  couple_with_heart_man_man: '👨‍❤️‍👨',
  couple_with_heart_woman_man: '👩‍❤️‍👨',
  couple_with_heart_woman_woman: '👩‍❤️‍👩',
  couplekiss: '💏',
  couplekiss_man_man: '👨‍❤️‍💋‍👨',
  couplekiss_man_woman: '👩‍❤️‍💋‍👨',
  couplekiss_woman_woman: '👩‍❤️‍💋‍👩',
  cow: '🐮',
  cow2: '🐄',
  cowboy_hat_face: '🤠',
  crab: '🦀',
  crap: '💩',
  crayon: '🖍️',
  cream: '💰',
  credit_card: '💳',
  crescent_moon: '🌙',
  cricket: '🦗',
  cricket_game: '🏏',
  croatia: '🇭🇷',
  crocodile: '🐊',
  croissant: '🥐',
  crossed_fingers: '🤞',
  crossed_flags: '🎌',
  crossed_swords: '⚔️',
  crown: '👑',
  cruise: '🛳️',
  crush: '😍',
  crutch: '🩼',
  cry: '😭',
  crying_cat_face: '😿',
  crystal_ball: '🔮',
  cuba: '🇨🇺',
  cucumber: '🥒',
  cup_with_straw: '🥤',
  cupcake: '🧁',
  cupid: '💘',
  curacao: '🇨🇼',
  curling_stone: '🥌',
  curly_haired_man: '👨‍🦱',
  curly_haired_woman: '👩‍🦱',
  curly_loop: '➰',
  currency_exchange: '💱',
  curry: '🍛',
  cursing_face: '🤬',
  custard: '🍮',
  customs: '🛃',
  cut: '✂️',
  cut_of_meat: '🥩',
  cutlery: '🍴',
  cyclone: '🌀',
  cyprus: '🇨🇾',
  czech_republic: '🇨🇿',
  dad: '👨',
  dagger: '🗡️',
  dancer: '🕺',
  dancers: '👯',
  dancing_men: '👯‍♂️',
  dancing_women: '👯‍♀️',
  danger: '☠️',
  dango: '🍡',
  dark_sunglasses: '🕶️',
  dart: '🎯',
  dash: '💨',
  date: '📅',
  de: '🇩🇪',
  dead: '💀',
  deaf: '🙉',
  deaf_man: '🧏‍♂️',
  deaf_person: '🧏',
  deaf_woman: '🧏‍♀️',
  deal: '🤝',
  deciduous_tree: '🌳',
  deer: '🦌',
  denied: '🙅‍♀️',
  denmark: '🇩🇰',
  department_store: '🏬',
  derelict_house: '🏚️',
  desert: '🏜️',
  desert_island: '🏝️',
  design: '🎨',
  desktop: '💻',
  desktop_computer: '🖥️',
  dessert: '🍰',
  detective: '🕵️',
  devil: '👿',
  diamond: '💎',
  diamond_shape_with_a_dot_inside: '💠',
  diamonds: '♦️',
  dice: '🎲',
  diego_garcia: '🇩🇬',
  dining: '🍽️',
  dinner: '🍽️',
  dinosaur: '🦖',
  directory: '📁',
  disappointed: '😞',
  disappointed_relieved: '😥',
  disapprove: '👎',
  disco: '🪩',
  disguised_face: '🥸',
  disgusted: '🤢',
  diving_mask: '🤿',
  diya_lamp: '🪔',
  dizzy: '💫',
  dizzy_face: '😵',
  djibouti: '🇩🇯',
  dna: '🧬',
  do_not_litter: '🚯',
  doctor: '👩‍⚕️',
  document: '📝',
  dodo: '🦤',
  dog: '🐩',
  dog2: '🐕',
  dollar: '💸',
  dolls: '🎎',
  dolphin: '🐬',
  dominica: '🇩🇲',
  dominican_republic: '🇩🇴',
  donkey: '🫏',
  door: '🚪',
  dotted_line_face: '🫥',
  doughnut: '🍩',
  dove: '🕊️',
  dragon: '🐉',
  dragon_face: '🐲',
  drama: '🎭',
  dread: '🫠',
  dress: '👗',
  drink: '🍺',
  drinks: '🍻',
  dromedary_camel: '🐪',
  drooling_face: '🤤',
  drop_of_blood: '🩸',
  droplet: '💧',
  drum: '🥁',
  duck: '🦆',
  dumpling: '🥟',
  dvd: '📀',
  'e-mail': '📧',
  eagle: '🦅',
  ear: '👂',
  ear_of_rice: '🌾',
  ear_with_hearing_aid: '🦻',
  earphones: '🎧',
  earth_africa: '🌍',
  earth_americas: '🌎',
  earth_asia: '🌏',
  ecuador: '🇪🇨',
  education: '🎓',
  egg: '🥚',
  eggplant: '🍆',
  egypt: '🇪🇬',
  eight: '8️⃣',
  eight_pointed_black_star: '✴️',
  eight_spoked_asterisk: '✳️',
  eject_button: '⏏️',
  el_salvador: '🇸🇻',
  electric_plug: '🔌',
  elephant: '🐘',
  elevator: '🛗',
  elf: '🧝',
  elf_man: '🧝‍♂️',
  elf_woman: '🧝‍♀️',
  email: '📧',
  emergency: '🆘',
  empty_nest: '🪹',
  end: '🔚',
  engaged: '💍',
  england: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  envelope: '✉️',
  envelope_with_arrow: '📩',
  environment: '♻️',
  equatorial_guinea: '🇬🇶',
  eritrea: '🇪🇷',
  es: '🇪🇸',
  espresso: '☕',
  estonia: '🇪🇪',
  ethiopia: '🇪🇹',
  eu: '🇪🇺',
  euro: '💶',
  european_castle: '🏰',
  european_post_office: '🏤',
  european_union: '🇪🇺',
  evergreen_tree: '🌲',
  evil: '👿',
  exclamation: '❗',
  exercise: '🏃‍♀️',
  explode: '💥',
  exploding_head: '🤯',
  expressionless: '😑',
  eye: '👁️',
  eye_speech_bubble: '👁️‍🗨️',
  eyeglasses: '👓',
  eyes: '👀',
  face_exhaling: '😮‍💨',
  face_holding_back_tears: '🥹',
  face_in_clouds: '😶‍🌫️',
  face_with_diagonal_mouth: '🫤',
  face_with_head_bandage: '🤕',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  face_with_peeking_eye: '🫣',
  face_with_spiral_eyes: '😵‍💫',
  face_with_thermometer: '🤒',
  facepalm: '🤦',
  facepunch: '👊',
  factory: '🏭',
  factory_worker: '🧑‍🏭',
  fairy: '🧚',
  fairy_man: '🧚‍♂️',
  fairy_woman: '🧚‍♀️',
  falafel: '🧆',
  falkland_islands: '🇫🇰',
  fallen_leaf: '🍂',
  family: '👪',
  family_man_boy: '👨‍👦',
  family_man_boy_boy: '👨‍👦‍👦',
  family_man_girl: '👨‍👧',
  family_man_girl_boy: '👨‍👧‍👦',
  family_man_girl_girl: '👨‍👧‍👧',
  family_man_man_boy: '👨‍👨‍👦',
  family_man_man_boy_boy: '👨‍👨‍👦‍👦',
  family_man_man_girl: '👨‍👨‍👧',
  family_man_man_girl_boy: '👨‍👨‍👧‍👦',
  family_man_man_girl_girl: '👨‍👨‍👧‍👧',
  family_man_woman_boy: '👨‍👩‍👦',
  family_man_woman_boy_boy: '👨‍👩‍👦‍👦',
  family_man_woman_girl: '👨‍👩‍👧',
  family_man_woman_girl_boy: '👨‍👩‍👧‍👦',
  family_man_woman_girl_girl: '👨‍👩‍👧‍👧',
  family_woman_boy: '👩‍👦',
  family_woman_boy_boy: '👩‍👦‍👦',
  family_woman_girl: '👩‍👧',
  family_woman_girl_boy: '👩‍👧‍👦',
  family_woman_girl_girl: '👩‍👧‍👧',
  family_woman_woman_boy: '👩‍👩‍👦',
  family_woman_woman_boy_boy: '👩‍👩‍👦‍👦',
  family_woman_woman_girl: '👩‍👩‍👧',
  family_woman_woman_girl_boy: '👩‍👩‍👧‍👦',
  family_woman_woman_girl_girl: '👩‍👩‍👧‍👧',
  farmer: '🧑‍🌾',
  faroe_islands: '🇫🇴',
  fast: '💨',
  fast_forward: '⏩',
  father: '👨',
  fax: '📠',
  fearful: '😨',
  feather: '🪶',
  feet: '🐾',
  female_detective: '🕵️‍♀️',
  female_sign: '♀️',
  ferris_wheel: '🎡',
  ferry: '⛴️',
  festival: '🎆',
  field_hockey: '🏑',
  fiji: '🇫🇯',
  file_cabinet: '🗄️',
  file_folder: '📁',
  film: '🎦',
  film_projector: '📽️',
  film_strip: '🎞️',
  finish: '🏁',
  finland: '🇫🇮',
  fire: '🔥',
  fire_engine: '🚒',
  fire_extinguisher: '🧯',
  firecracker: '🧨',
  firefighter: '🧑‍🚒',
  fireworks: '🎆',
  first_quarter_moon: '🌓',
  first_quarter_moon_with_face: '🌛',
  fish: '🐟',
  fish_cake: '🍥',
  fishing_pole_and_fish: '🎣',
  fist: '✊',
  fist_left: '🤛',
  fist_oncoming: '👊',
  fist_raised: '✊',
  fist_right: '🤜',
  five: '5️⃣',
  flag: '🇺🇸',
  flags: '🎏',
  flamingo: '🦩',
  flashlight: '🔦',
  flat_shoe: '🥿',
  flatbread: '🫓',
  fleur_de_lis: '⚜️',
  flex: '💪',
  flight: '🛩️',
  flight_arrival: '🛬',
  flight_departure: '🛫',
  flipper: '🐬',
  flirt: '😘',
  floppy_disk: '💾',
  flower: '🌷',
  flower_playing_cards: '🎴',
  flowers: '💐',
  flushed: '😳',
  flute: '🪈',
  fly: '🪰',
  flying_disc: '🥏',
  flying_saucer: '🛸',
  fog: '🌫️',
  foggy: '🌁',
  folding_hand_fan: '🪭',
  fondue: '🫕',
  foot: '🦶',
  football: '🏈',
  footprints: '👣',
  forbidden: '🚫',
  fork_and_knife: '🍴',
  formal: '👔',
  fortune: '🔮',
  fortune_cookie: '🥠',
  foul: '🤬',
  fountain: '⛲',
  fountain_pen: '🖋️',
  four: '4️⃣',
  four_leaf_clover: '🍀',
  fox_face: '🦊',
  fr: '🇫🇷',
  framed_picture: '🖼️',
  france: '🇫🇷',
  free: '🆓',
  freezing: '🥶',
  french: '🇫🇷',
  french_guiana: '🇬🇫',
  french_polynesia: '🇵🇫',
  french_southern_territories: '🇹🇫',
  fresh: '🆕',
  fried_egg: '🍳',
  fried_shrimp: '🍤',
  fries: '🍟',
  frog: '🐸',
  frowning: '😦',
  frowning_face: '☹️',
  frowning_man: '🙍‍♂️',
  frowning_person: '🙍',
  frowning_woman: '🙍‍♀️',
  fruit: '🍓',
  fu: '🖕',
  fuelpump: '⛽',
  full_moon: '🌕',
  full_moon_with_face: '🌝',
  funeral: '⚰️',
  funeral_urn: '⚱️',
  fungus: '🍄',
  gabon: '🇬🇦',
  gambia: '🇬🇲',
  gambling: '🎲',
  game: '👾',
  game_die: '🎲',
  garlic: '🧄',
  gasp: '😲',
  gb: '🇬🇧',
  gear: '⚙️',
  geek: '🤓',
  gem: '💎',
  gemini: '♊',
  genie: '🧞',
  genie_man: '🧞‍♂️',
  genie_woman: '🧞‍♀️',
  georgia: '🇬🇪',
  germ: '🦠',
  germany: '🇩🇪',
  ghana: '🇬🇭',
  ghost: '👻',
  gibraltar: '🇬🇮',
  gift: '🎁',
  gift_heart: '💝',
  ginger_root: '🫚',
  giraffe: '🦒',
  girl: '👧',
  girls: '👩',
  glasses: '👓',
  global: '🌐',
  globe: '🌏',
  globe_with_meridians: '🌐',
  gloves: '🧤',
  goal_net: '🥅',
  goat: '🐐',
  goggles: '🥽',
  gold: '🥇',
  golf: '⛳',
  golfing: '🏌️',
  golfing_man: '🏌️‍♂️',
  golfing_woman: '🏌️‍♀️',
  goodbye: '👋',
  goofy: '🤪',
  goose: '🪿',
  gorilla: '🦍',
  graduation: '🎓',
  grapes: '🍇',
  graph: '📉',
  gratitude: '🥹',
  greece: '🇬🇷',
  green: '♻️',
  green_apple: '🍏',
  green_book: '📗',
  green_circle: '🟢',
  green_heart: '💚',
  green_salad: '🥗',
  green_square: '🟩',
  greenland: '🇬🇱',
  grenada: '🇬🇩',
  grey_exclamation: '❕',
  grey_heart: '🩶',
  grey_question: '❔',
  grimacing: '😬',
  grin: '😁',
  grinning: '😀',
  groggy: '🥴',
  groom: '🤵',
  group: '👥',
  guadeloupe: '🇬🇵',
  guam: '🇬🇺',
  guard: '💂',
  guardsman: '💂‍♂️',
  guardswoman: '💂‍♀️',
  guatemala: '🇬🇹',
  guernsey: '🇬🇬',
  guide_dog: '🦮',
  guinea: '🇬🇳',
  guinea_bissau: '🇬🇼',
  guitar: '🎸',
  gun: '🔫',
  guyana: '🇬🇾',
  gym: '🏋️‍♀️',
  haha: '😆',
  hair_pick: '🪮',
  haircut: '💇',
  haircut_man: '💇‍♂️',
  haircut_woman: '💇‍♀️',
  haiti: '🇭🇹',
  halloween: '🎃',
  halt: '🙅‍♀️',
  hamburger: '🍔',
  hammer: '🔨',
  hammer_and_pick: '⚒️',
  hammer_and_wrench: '🛠️',
  hamsa: '🪬',
  hamster: '🐹',
  hand: '✋',
  hand_over_mouth: '🤭',
  hand_with_index_finger_and_thumb_crossed: '🫰',
  handbag: '👜',
  handball_person: '🤾',
  handshake: '🤝',
  hankey: '💩',
  happy: '😆',
  hash: '#️⃣',
  hat: '🎩',
  hatched_chick: '🐥',
  hatching_chick: '🐣',
  headphones: '🎧',
  headstone: '🪦',
  health: '💊',
  health_worker: '🧑‍⚕️',
  hear: '👂',
  hear_no_evil: '🙉',
  heard_mcdonald_islands: '🇭🇲',
  heart: '❤️',
  heart_decoration: '💟',
  heart_eyes: '😍',
  heart_eyes_cat: '😻',
  heart_hands: '🫶',
  heart_on_fire: '❤️‍🔥',
  heartbeat: '💓',
  heartpulse: '💗',
  hearts: '♥️',
  heat: '🥵',
  heavy_check_mark: '✔️',
  heavy_division_sign: '➗',
  heavy_dollar_sign: '💲',
  heavy_equals_sign: '🟰',
  heavy_exclamation_mark: '❗',
  heavy_heart_exclamation: '❣️',
  heavy_minus_sign: '➖',
  heavy_multiplication_x: '✖️',
  heavy_plus_sign: '➕',
  hedgehog: '🦔',
  helicopter: '🚁',
  helmet: '👷‍♀️',
  help: '🆘',
  herb: '🌿',
  hibiscus: '🌺',
  high_brightness: '🔆',
  high_heel: '👠',
  highfive: '✋',
  hijab: '🧕',
  hiking_boot: '🥾',
  hindu_temple: '🛕',
  hippopotamus: '🦛',
  hocho: '🔪',
  hole: '🕳️',
  home: '👪',
  honduras: '🇭🇳',
  honey_pot: '🍯',
  honeybee: '🐝',
  hong_kong: '🇭🇰',
  honk: '🪿',
  hook: '🪝',
  hooray: '🎉',
  hope: '🙏',
  hopeful: '🤞',
  horns: '👿',
  horror: '🙀',
  horse: '🐴',
  horse_racing: '🏇',
  hospital: '💉',
  hot: '😅',
  hot_face: '🥵',
  hot_pepper: '🌶️',
  hotdog: '🌭',
  hotel: '🏨',
  hotsprings: '♨️',
  hourglass: '⌛',
  hourglass_flowing_sand: '⏳',
  house: '🏠',
  house_with_garden: '🏡',
  houses: '🏘️',
  hugs: '🤗',
  hungary: '🇭🇺',
  hurt: '🤕',
  hush: '🙊',
  hushed: '😯',
  hut: '🛖',
  hyacinth: '🪻',
  ice: '🥶',
  ice_cream: '🍨',
  ice_cube: '🧊',
  ice_hockey: '🏒',
  ice_skate: '⛸️',
  icecream: '🍦',
  iceland: '🇮🇸',
  id: '🆔',
  idea: '💡',
  identification_card: '🪪',
  ideograph_advantage: '🉐',
  ignore: '🙈',
  ill: '😷',
  imp: '👿',
  impressed: '😮',
  inbox_tray: '📥',
  incoming: '📲',
  incoming_envelope: '📨',
  index_pointing_at_the_viewer: '🫵',
  india: '🇮🇳',
  indonesia: '🇮🇩',
  infinity: '♾️',
  information: '💁‍♀️',
  information_desk_person: '💁',
  information_source: 'ℹ️',
  innocent: '😇',
  international: '🌐',
  interrobang: '⁉️',
  investigate: '🔬',
  invisible: '🫥',
  iphone: '📱',
  iran: '🇮🇷',
  iraq: '🇮🇶',
  ireland: '🇮🇪',
  isle_of_man: '🇮🇲',
  israel: '🇮🇱',
  it: '🇮🇹',
  italy: '🇮🇹',
  ivory: '🇨🇮',
  izakaya_lantern: '🏮',
  jack_o_lantern: '🎃',
  jamaica: '🇯🇲',
  japan: '🇯🇵',
  japanese_castle: '🏯',
  japanese_goblin: '👺',
  japanese_ogre: '👹',
  jar: '🫙',
  jeans: '👖',
  jellyfish: '🪼',
  jersey: '🇯🇪',
  jigsaw: '🧩',
  jordan: '🇯🇴',
  joy: '😂',
  joy_cat: '😹',
  joystick: '🕹️',
  jp: '🇯🇵',
  judge: '🧑‍⚖️',
  juggling_person: '🤹',
  justice: '👩‍⚖️',
  kaaba: '🕋',
  kangaroo: '🦘',
  karl: '🌁',
  kazakhstan: '🇰🇿',
  keeling: '🇨🇨',
  kenya: '🇰🇪',
  key: '🔑',
  keyboard: '⌨️',
  keycap_ten: '🔟',
  khanda: '🪯',
  kick_scooter: '🛴',
  kimono: '👘',
  king: '👑',
  kiribati: '🇰🇮',
  kiss: '👄',
  kissing: '😗',
  kissing_cat: '😽',
  kissing_closed_eyes: '😚',
  kissing_heart: '😘',
  kissing_smiling_eyes: '😙',
  kite: '🪁',
  kiwi_fruit: '🥝',
  kneeling_man: '🧎‍♂️',
  kneeling_person: '🧎',
  kneeling_woman: '🧎‍♀️',
  knife: '🔪',
  knot: '🪢',
  koala: '🐨',
  koko: '🈁',
  korea: '🇰🇷',
  kosovo: '🇽🇰',
  kr: '🇰🇷',
  kuwait: '🇰🇼',
  kyrgyzstan: '🇰🇬',
  lab_coat: '🥼',
  label: '🏷️',
  laboratory: '🔬',
  lacrosse: '🥍',
  ladder: '🪜',
  lady_beetle: '🐞',
  lantern: '🏮',
  laos: '🇱🇦',
  large_blue_circle: '🔵',
  large_blue_diamond: '🔷',
  large_orange_diamond: '🔶',
  last_quarter_moon: '🌗',
  last_quarter_moon_with_face: '🌜',
  latin_cross: '✝️',
  latvia: '🇱🇻',
  laugh: '😄',
  laughing: '🤣',
  launch: '🚀',
  law: '👮‍♀️',
  leaf: '🍃',
  leafy_green: '🥬',
  leaves: '🍃',
  lebanon: '🇱🇧',
  ledger: '📒',
  left_luggage: '🛅',
  left_right_arrow: '↔️',
  left_speech_bubble: '🗨️',
  leftwards_arrow_with_hook: '↩️',
  leftwards_hand: '🫲',
  leftwards_pushing_hand: '🫷',
  leg: '🦵',
  lemon: '🍋',
  leo: '♌',
  leopard: '🐆',
  lesotho: '🇱🇸',
  letter: '✉️',
  letters: '🔠',
  level_slider: '🎚️',
  liar: '🤥',
  liberia: '🇱🇷',
  libra: '♎',
  library: '📚',
  libya: '🇱🇾',
  lick: '😋',
  liechtenstein: '🇱🇮',
  'life preserver': '🛟',
  light: '💡',
  light_blue_heart: '🩵',
  light_rail: '🚈',
  lightning: '⚡',
  limit: '⛔',
  link: '🔗',
  lion: '🦁',
  lips: '👄',
  lipstick: '💄',
  listen: '👂',
  lithuania: '🇱🇹',
  lizard: '🦎',
  llama: '🦙',
  lobster: '🦞',
  location: '📍',
  lock: '🔑',
  lock_with_ink_pen: '🔏',
  lol: '🤣',
  lollipop: '🍭',
  long_drum: '🪘',
  look: '👀',
  loop: '➿',
  lotion_bottle: '🧴',
  lotus: '🪷',
  lotus_position: '🧘',
  lotus_position_man: '🧘‍♂️',
  lotus_position_woman: '🧘‍♀️',
  loud_sound: '🔊',
  loudspeaker: '📢',
  love: '🫶',
  love_hotel: '🏩',
  love_letter: '💌',
  love_you_gesture: '🤟',
  low_battery: '🪫',
  low_brightness: '🔅',
  luck: '🍀',
  luggage: '🧳',
  lungs: '🫁',
  luxembourg: '🇱🇺',
  lying_face: '🤥',
  m: 'Ⓜ️',
  macau: '🇲🇴',
  macedonia: '🇲🇰',
  mad: '😠',
  madagascar: '🇲🇬',
  mag: '🔍',
  mag_right: '🔎',
  mage: '🧙',
  mage_man: '🧙‍♂️',
  mage_woman: '🧙‍♀️',
  magic_wand: '🪄',
  magnet: '🧲',
  mahjong: '🀄',
  mailbox: '📫',
  mailbox_closed: '📪',
  mailbox_with_mail: '📬',
  mailbox_with_no_mail: '📭',
  makeup: '💄',
  malawi: '🇲🇼',
  malaysia: '🇲🇾',
  maldives: '🇲🇻',
  male_detective: '🕵️‍♂️',
  male_sign: '♂️',
  mali: '🇲🇱',
  malta: '🇲🇹',
  mammoth: '🦣',
  man: '👨',
  man_artist: '👨‍🎨',
  man_astronaut: '👨‍🚀',
  man_beard: '🧔‍♂️',
  man_cartwheeling: '🤸‍♂️',
  man_cook: '👨‍🍳',
  man_dancing: '🕺',
  man_facepalming: '🤦‍♂️',
  man_factory_worker: '👨‍🏭',
  man_farmer: '👨‍🌾',
  man_feeding_baby: '👨‍🍼',
  man_firefighter: '👨‍🚒',
  man_health_worker: '👨‍⚕️',
  man_in_manual_wheelchair: '👨‍🦽',
  man_in_motorized_wheelchair: '👨‍🦼',
  man_in_tuxedo: '🤵‍♂️',
  man_judge: '👨‍⚖️',
  man_juggling: '🤹‍♂️',
  man_mechanic: '👨‍🔧',
  man_office_worker: '👨‍💼',
  man_pilot: '👨‍✈️',
  man_playing_handball: '🤾‍♂️',
  man_playing_water_polo: '🤽‍♂️',
  man_scientist: '👨‍🔬',
  man_shrugging: '🤷‍♂️',
  man_singer: '👨‍🎤',
  man_student: '👨‍🎓',
  man_teacher: '👨‍🏫',
  man_technologist: '👨‍💻',
  man_with_gua_pi_mao: '👲',
  man_with_probing_cane: '👨‍🦯',
  man_with_turban: '👳‍♂️',
  man_with_veil: '👰‍♂️',
  mandarin: '🍊',
  mango: '🥭',
  manicure: '💅',
  mans_shoe: '👞',
  mantelpiece_clock: '🕰️',
  manual_wheelchair: '🦽',
  maple_leaf: '🍁',
  maracas: '🪇',
  marathon: '🎽',
  marriage: '💍',
  marshall_islands: '🇲🇭',
  martial_arts_uniform: '🥋',
  martinique: '🇲🇶',
  mask: '😷',
  massage: '💆',
  massage_man: '💆‍♂️',
  massage_woman: '💆‍♀️',
  mate: '🧉',
  mauritania: '🇲🇷',
  mauritius: '🇲🇺',
  mayotte: '🇾🇹',
  meat: '🍗',
  meat_on_bone: '🍖',
  mechanic: '🧑‍🔧',
  mechanical_arm: '🦾',
  mechanical_leg: '🦿',
  medal_military: '🎖️',
  medal_sports: '🏅',
  medical_symbol: '⚕️',
  medicine: '💊',
  meditation: '🧘‍♀️',
  mega: '📣',
  meh: '😒',
  melon: '🍈',
  melting_face: '🫠',
  memo: '📝',
  men_wrestling: '🤼‍♂️',
  mending_heart: '❤️‍🩹',
  menorah: '🕎',
  mens: '🚹',
  mermaid: '🧜‍♀️',
  merman: '🧜‍♂️',
  merperson: '🧜',
  metal: '🤘',
  metrics: '📊',
  metro: '🚇',
  mexico: '🇲🇽',
  microbe: '🦠',
  micronesia: '🇫🇲',
  microphone: '🎤',
  microscope: '🔬',
  middle_finger: '🖕',
  milestone: '🏁',
  military_helmet: '🪖',
  milk: '🍼',
  milk_glass: '🥛',
  milky_way: '🌌',
  mind: '🤯',
  minibus: '🚐',
  minidisc: '💽',
  minus1: '👎',
  mirror: '🪞',
  mirror_ball: '🪩',
  mobile: '📱',
  mobile_phone_off: '📴',
  moldova: '🇲🇩',
  monaco: '🇲🇨',
  money: '💵',
  money_mouth_face: '🤑',
  money_with_wings: '💸',
  moneybag: '💰',
  mongolia: '🇲🇳',
  monkey: '🐒',
  monkey_face: '🐵',
  monocle_face: '🧐',
  monorail: '🚝',
  monster: '👹',
  montenegro: '🇲🇪',
  montserrat: '🇲🇸',
  moon: '🌔',
  moon_cake: '🥮',
  moose: '🫎',
  morning: '⏰',
  morocco: '🇲🇦',
  mortar_board: '🎓',
  mosque: '🕌',
  mosquito: '🦟',
  motor_boat: '🛥️',
  motor_scooter: '🛵',
  motorcycle: '🏍️',
  motorized_wheelchair: '🦼',
  motorway: '🛣️',
  mount_fuji: '🗻',
  mountain: '⛰️',
  mountain_bicyclist: '🚵',
  mountain_biking_man: '🚵‍♂️',
  mountain_biking_woman: '🚵‍♀️',
  mountain_cableway: '🚠',
  mountain_railway: '🚞',
  mountain_snow: '🏔️',
  mouse: '🐭',
  mouse_trap: '🪤',
  mouse2: '🐁',
  movie: '🎦',
  movie_camera: '🎥',
  moyai: '🗿',
  mozambique: '🇲🇿',
  mrs_claus: '🤶',
  mule: '🫏',
  muscle: '💪',
  mushroom: '🍄',
  music: '🎧',
  musical_keyboard: '🎹',
  musical_note: '🎵',
  musical_score: '🎼',
  mustache: '👨',
  mute: '📴',
  mx_claus: '🧑‍🎄',
  myanmar: '🇲🇲',
  nail_care: '💅',
  name_badge: '📛',
  namibia: '🇳🇦',
  national_park: '🏞️',
  nauru: '🇳🇷',
  nauseated_face: '🤢',
  nazar_amulet: '🧿',
  necktie: '👔',
  needle: '💉',
  negative_squared_cross_mark: '❎',
  nepal: '🇳🇵',
  nerd_face: '🤓',
  nervous: '😥',
  nest_with_eggs: '🪺',
  nesting_dolls: '🪆',
  netherlands: '🇳🇱',
  neutral_face: '😐',
  new: '🆕',
  new_caledonia: '🇳🇨',
  new_moon: '🌑',
  new_moon_with_face: '🌚',
  new_zealand: '🇳🇿',
  newborn: '👶',
  newspaper: '📰',
  newspaper_roll: '🗞️',
  next_track_button: '⏭️',
  ng: '🆖',
  ng_man: '🙅‍♂️',
  ng_woman: '🙅‍♀️',
  nicaragua: '🇳🇮',
  niger: '🇳🇪',
  nigeria: '🇳🇬',
  night: '🌙',
  night_with_stars: '🌃',
  nine: '9️⃣',
  ninja: '🥷',
  niue: '🇳🇺',
  no_bell: '🔕',
  no_bicycles: '🚳',
  no_entry: '⛔',
  no_entry_sign: '🚫',
  no_good: '🙅',
  no_good_man: '🙅‍♂️',
  no_good_woman: '🙅‍♀️',
  no_mobile_phones: '📵',
  no_mouth: '😶',
  no_pedestrians: '🚷',
  no_smoking: '🚭',
  'non-potable_water': '🚱',
  noodle: '🍜',
  norfolk_island: '🇳🇫',
  north_korea: '🇰🇵',
  northern_mariana_islands: '🇲🇵',
  norway: '🇳🇴',
  nose: '👃',
  note: '📝',
  notebook: '📓',
  notebook_with_decorative_cover: '📔',
  notes: '🎶',
  notification: '🔔',
  number: '#️⃣',
  numbers: '🔢',
  nurse: '👩‍⚕️',
  nursing: '🤱',
  nut_and_bolt: '🔩',
  o: '⭕',
  o2: '🅾️',
  ocean: '🌊',
  octopus: '🐙',
  oden: '🍢',
  off: '📴',
  office: '🏢',
  office_worker: '🧑‍💼',
  oil_drum: '🛢️',
  ok: '🆗',
  ok_hand: '👌',
  ok_man: '🙆‍♂️',
  ok_person: '🙆',
  ok_woman: '🙆‍♀️',
  old_key: '🗝️',
  older_adult: '🧓',
  older_man: '👴',
  older_woman: '👵',
  olive: '🫒',
  om: '🕉️',
  oman: '🇴🇲',
  on: '🔛',
  oncoming_automobile: '🚘',
  oncoming_bus: '🚍',
  oncoming_police_car: '🚔',
  oncoming_taxi: '🚖',
  one: '1️⃣',
  one_piece_swimsuit: '🩱',
  onion: '🧅',
  oops: '😨',
  open_book: '📖',
  open_file_folder: '📂',
  open_hands: '👐',
  open_mouth: '😮',
  open_umbrella: '☂️',
  ophiuchus: '⛎',
  orange: '🍊',
  orange_book: '📙',
  orange_circle: '🟠',
  orange_heart: '🧡',
  orange_square: '🟧',
  orangutan: '🦧',
  orbit: '🛰️',
  orthodox_cross: '☦️',
  otter: '🦦',
  outbox_tray: '📤',
  owl: '🦉',
  ox: '🐂',
  oyster: '🦪',
  package: '📦',
  paella: '🥘',
  page_facing_up: '📄',
  page_with_curl: '📃',
  pager: '📟',
  paint: '🎨',
  paintbrush: '🖌️',
  painter: '👩‍🎨',
  pakistan: '🇵🇰',
  palau: '🇵🇼',
  palestinian_territories: '🇵🇸',
  palm_down_hand: '🫳',
  palm_tree: '🌴',
  palm_up_hand: '🫴',
  palms_up_together: '🤲',
  panama: '🇵🇦',
  pancakes: '🥞',
  panda_face: '🐼',
  pants: '👖',
  paperclip: '📎',
  paperclips: '🖇️',
  papua_new_guinea: '🇵🇬',
  parachute: '🪂',
  paraguay: '🇵🇾',
  parasol_on_ground: '⛱️',
  parents: '👪',
  parking: '🅿️',
  parrot: '🦜',
  part_alternation_mark: '〽️',
  partly_sunny: '⛅',
  party: '🪩',
  partying_face: '🥳',
  passenger_ship: '🛳️',
  passport_control: '🛂',
  password: '🔑',
  pasta: '🍝',
  pause_button: '⏸️',
  paw_prints: '🐾',
  pea_pod: '🫛',
  peace: '🕊️',
  peace_symbol: '☮️',
  peach: '🍑',
  peacock: '🦚',
  peanuts: '🥜',
  pear: '🍐',
  pen: '🖊️',
  pencil: '📝',
  pencil2: '✏️',
  penguin: '🐧',
  pensive: '😔',
  people_holding_hands: '🧑‍🤝‍🧑',
  people_hugging: '🫂',
  perfect: '💯',
  performing_arts: '🎭',
  persevere: '😣',
  person_bald: '🧑‍🦲',
  person_curly_hair: '🧑‍🦱',
  person_feeding_baby: '🧑‍🍼',
  person_fencing: '🤺',
  person_in_manual_wheelchair: '🧑‍🦽',
  person_in_motorized_wheelchair: '🧑‍🦼',
  person_in_tuxedo: '🤵',
  person_red_hair: '🧑‍🦰',
  person_white_hair: '🧑‍🦳',
  person_with_crown: '🫅',
  person_with_probing_cane: '🧑‍🦯',
  person_with_turban: '👳',
  person_with_veil: '👰',
  peru: '🇵🇪',
  pet: '🐹',
  petri_dish: '🧫',
  phew: '😥',
  philippines: '🇵🇭',
  phone: '📞',
  photo: '📸',
  piano: '🎹',
  pick: '⛏️',
  pickup_truck: '🛻',
  pie: '🥧',
  pig: '🐷',
  pig_nose: '🐽',
  pig2: '🐖',
  pill: '💊',
  pilot: '🧑‍✈️',
  pinata: '🪅',
  pinched_fingers: '🤌',
  pinching_hand: '🤏',
  pineapple: '🍍',
  ping_pong: '🏓',
  pink_heart: '🩷',
  pirate: '☠️',
  pirate_flag: '🏴‍☠️',
  pisces: '♓',
  pitcairn_islands: '🇵🇳',
  pizza: '🍕',
  placard: '🪧',
  place_of_worship: '🛐',
  plant: '🌱',
  plate_with_cutlery: '🍽️',
  play: '🎮',
  play_or_pause_button: '⏯️',
  playground_slide: '🛝',
  pleading_face: '🥺',
  please: '🙏',
  pleased: '☺️',
  plunger: '🪠',
  plus1: '👍',
  podcast: '📻',
  point_down: '👇',
  point_left: '👈',
  point_right: '👉',
  point_up: '☝️',
  point_up_2: '👆',
  poison: '💀',
  poland: '🇵🇱',
  polar_bear: '🐻‍❄️',
  police_car: '🚓',
  police_officer: '👮',
  policeman: '👮‍♂️',
  policewoman: '👮‍♀️',
  poodle: '🐩',
  pool: '🎱',
  poop: '💩',
  popcorn: '🍿',
  portugal: '🇵🇹',
  post_office: '🏣',
  postal_horn: '📯',
  postbox: '📮',
  potable_water: '🚰',
  potato: '🥔',
  potted_plant: '🪴',
  pouch: '👝',
  poultry_leg: '🍗',
  pound: '💷',
  pouring_liquid: '🫗',
  pout: '😡',
  pouting_cat: '😾',
  pouting_face: '🙎',
  pouting_man: '🙎‍♂️',
  pouting_woman: '🙎‍♀️',
  power: '🔋',
  praise: '👏',
  prank: '😝',
  pray: '🙏',
  prayer_beads: '📿',
  pregnant_man: '🫃',
  pregnant_person: '🫄',
  pregnant_woman: '🤰',
  present: '🎁',
  press: '🗞️',
  pretzel: '🥨',
  previous_track_button: '⏮️',
  pride: '🏳️‍🌈',
  prince: '🤴',
  princess: '👸',
  printer: '🖨️',
  private: '🔒',
  probing_cane: '🦯',
  professor: '👩‍🏫',
  prosper: '🖖',
  proud: '😊',
  puerto_rico: '🇵🇷',
  punch: '👊',
  puppy: '🥺',
  purple_circle: '🟣',
  purple_heart: '💜',
  purple_square: '🟪',
  purse: '👛',
  pushpin: '📌',
  put_litter_in_its_place: '🚮',
  qatar: '🇶🇦',
  queen: '👑',
  question: '❓',
  quiet: '🤫',
  rabbit: '🐰',
  rabbit2: '🐇',
  raccoon: '🦝',
  racehorse: '🐎',
  racing_car: '🏎️',
  radio: '📻',
  radio_button: '🔘',
  radioactive: '☢️',
  rage: '😡',
  railway_car: '🚃',
  railway_track: '🛤️',
  rain: '☔',
  rainbow: '🌈',
  rainbow_flag: '🏳️‍🌈',
  raised_back_of_hand: '🤚',
  raised_eyebrow: '🤨',
  raised_hand: '✋',
  raised_hand_with_fingers_splayed: '🖐️',
  raised_hands: '🙌',
  raising_hand: '🙋',
  raising_hand_man: '🙋‍♂️',
  raising_hand_woman: '🙋‍♀️',
  ram: '🐏',
  ramen: '🍜',
  rat: '🐀',
  razor: '🪒',
  receipt: '🧾',
  record_button: '⏺️',
  recorder: '🪈',
  recycle: '♻️',
  red_car: '🚗',
  red_circle: '🔴',
  red_envelope: '🧧',
  red_haired_man: '👨‍🦰',
  red_haired_woman: '👩‍🦰',
  red_square: '🟥',
  registered: '®️',
  relaxed: '☺️',
  relieved: '😌',
  reminder_ribbon: '🎗️',
  repeat: '🔁',
  repeat_one: '🔂',
  rescue_worker_helmet: '⛑️',
  research: '👩‍🔬',
  respect: '🙇‍♀️',
  restroom: '🚾',
  retro: '👾',
  return: '↩️',
  reunion: '🇷🇪',
  revolving_hearts: '💞',
  rewind: '⏪',
  rhinoceros: '🦏',
  ribbon: '🎀',
  rice: '🍚',
  rice_ball: '🍙',
  rice_cracker: '🍘',
  rice_scene: '🎑',
  rich: '🤑',
  right_anger_bubble: '🗯️',
  rightwards_hand: '🫱',
  rightwards_pushing_hand: '🫸',
  ring: '💍',
  ring_buoy: '🛟',
  ringed_planet: '🪐',
  robot: '🤖',
  rock: '🎸',
  rocket: '🚀',
  rockstar: '👩‍🎤',
  rofl: '🤣',
  roll_eyes: '🙄',
  roll_of_paper: '🧻',
  roller_coaster: '🎢',
  roller_skate: '🛼',
  romania: '🇷🇴',
  rooster: '🐓',
  rose: '🌹',
  rosette: '🏵️',
  rotating_light: '🚨',
  round_pushpin: '📍',
  rowboat: '🚣',
  rowing_man: '🚣‍♂️',
  rowing_woman: '🚣‍♀️',
  royal: '👑',
  ru: '🇷🇺',
  rugby_football: '🏉',
  runner: '🏃',
  running: '👟',
  running_man: '🏃‍♂️',
  running_shirt_with_sash: '🎽',
  running_woman: '🏃‍♀️',
  russia: '🇷🇺',
  rwanda: '🇷🇼',
  sa: '🈂️',
  sad: '😿',
  safety_pin: '🧷',
  safety_vest: '🦺',
  sagittarius: '♐',
  sailboat: '⛵',
  sake: '🍶',
  salt: '🧂',
  saluting_face: '🫡',
  samoa: '🇼🇸',
  san_marino: '🇸🇲',
  sandal: '👡',
  sandwich: '🥪',
  santa: '🤶',
  sao_tome_principe: '🇸🇹',
  sarcasm: '🫠',
  sari: '🥻',
  sassy_man: '💁‍♂️',
  sassy_woman: '💁‍♀️',
  satellite: '📡',
  satisfied: '😆',
  saudi_arabia: '🇸🇦',
  sauna_man: '🧖‍♂️',
  sauna_person: '🧖',
  sauna_woman: '🧖‍♀️',
  sauropod: '🦕',
  save: '💾',
  saxophone: '🎷',
  scared: '😨',
  scarf: '🧣',
  schedule: '📆',
  school: '🏫',
  school_satchel: '🎒',
  science: '🔬',
  scientist: '🧑‍🔬',
  scissors: '✂️',
  score: '💯',
  scorpion: '🦂',
  scorpius: '♏',
  scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  scream: '😱',
  scream_cat: '🙀',
  screen: '💻',
  screwdriver: '🪛',
  scroll: '📜',
  sea: '🌊',
  seal: '🦭',
  search: '🔍',
  seat: '💺',
  secret: '㊙️',
  security: '🔐',
  see: '👀',
  see_no_evil: '🙈',
  seedling: '🌱',
  selfie: '🤳',
  semaphore: '🚦',
  senegal: '🇸🇳',
  sensu: '🪭',
  serbia: '🇷🇸',
  service_dog: '🐕‍🦺',
  seven: '7️⃣',
  sewing_needle: '🪡',
  seychelles: '🇸🇨',
  shaker: '🪇',
  shaking_face: '🫨',
  shallow_pan_of_food: '🥘',
  shamrock: '☘️',
  shark: '🦈',
  shaved_ice: '🍧',
  sheep: '🐑',
  shell: '🐚',
  shield: '🛡️',
  shinto_shrine: '⛩️',
  shiny: '✨',
  ship: '🚀',
  shipping: '📦',
  shirt: '👕',
  shit: '💩',
  shock: '🫨',
  shocked: '😱',
  shoe: '👡',
  shoot: '🔫',
  shopping: '🛍️',
  shopping_cart: '🛒',
  shorts: '🩳',
  shower: '🚿',
  shrimp: '🦐',
  shrug: '🤷',
  shuffle: '🔀',
  shushing_face: '🤫',
  sick: '🤧',
  sierra_leone: '🇸🇱',
  signal: '📡',
  signal_strength: '📶',
  silence: '😯',
  silly: '😜',
  silver: '🥈',
  sing: '🎤',
  singapore: '🇸🇬',
  singer: '🧑‍🎤',
  sint_maarten: '🇸🇽',
  six: '6️⃣',
  six_pointed_star: '🔯',
  skateboard: '🛹',
  skating: '⛸️',
  ski: '🎿',
  skier: '⛷️',
  skull: '💀',
  skull_and_crossbones: '☠️',
  skunk: '🦨',
  skyline: '🏙️',
  sled: '🛷',
  sleeping: '💤',
  sleeping_bed: '🛌',
  sleepy: '😪',
  sleuth: '🕵️‍♀️',
  slightly_frowning_face: '🙁',
  slightly_smiling_face: '🙂',
  slot_machine: '🎰',
  sloth: '🦥',
  slovakia: '🇸🇰',
  slovenia: '🇸🇮',
  slow: '🐌',
  small_airplane: '🛩️',
  small_blue_diamond: '🔹',
  small_orange_diamond: '🔸',
  small_red_triangle: '🔺',
  small_red_triangle_down: '🔻',
  smartphone: '📱',
  smell: '👃',
  smile: '😄',
  smile_cat: '😸',
  smiley: '😃',
  smiley_cat: '😺',
  smiling_face_with_tear: '🥲',
  smiling_face_with_three_hearts: '🥰',
  smiling_imp: '😈',
  smirk: '😏',
  smirk_cat: '😼',
  smoking: '🚬',
  smug: '😤',
  snail: '🐌',
  snake: '🐍',
  sneaker: '👟',
  sneezing_face: '🤧',
  snowboarder: '🏂',
  snowflake: '❄️',
  snowman: '⛄',
  snowman_with_snow: '☃️',
  soap: '🧼',
  sob: '😭',
  soccer: '⚽',
  socks: '🧦',
  softball: '🥎',
  solomon_islands: '🇸🇧',
  somalia: '🇸🇴',
  soon: '🔜',
  sos: '🆘',
  sound: '🔔',
  south_africa: '🇿🇦',
  south_georgia_south_sandwich_islands: '🇬🇸',
  south_sudan: '🇸🇸',
  spa: '💆‍♀️',
  space: '🛰️',
  space_invader: '👾',
  spades: '♠️',
  spaghetti: '🍝',
  spain: '🇪🇸',
  sparkle: '❇️',
  sparkler: '🎇',
  sparkles: '✨',
  sparkling_heart: '💖',
  speak_no_evil: '🙊',
  speaker: '🔈',
  speaking_head: '🗣️',
  speech_balloon: '💬',
  speechless: '😯',
  speed: '🐎',
  speedboat: '🚤',
  spicy: '🌶️',
  spider: '🕷️',
  spider_web: '🕸️',
  spiral_calendar: '🗓️',
  spiral_notepad: '🗒️',
  spock: '🖖',
  sponge: '🧽',
  spoon: '🥄',
  sport: '👟',
  sports: '🎾',
  spring: '🌸',
  squid: '🦑',
  sri_lanka: '🇱🇰',
  st_barthelemy: '🇧🇱',
  st_helena: '🇸🇭',
  st_kitts_nevis: '🇰🇳',
  st_lucia: '🇱🇨',
  st_martin: '🇲🇫',
  st_pierre_miquelon: '🇵🇲',
  st_vincent_grenadines: '🇻🇨',
  stadium: '🏟️',
  standing_man: '🧍‍♂️',
  standing_person: '🧍',
  standing_woman: '🧍‍♀️',
  star: '⭐',
  star_and_crescent: '☪️',
  star_of_david: '✡️',
  star_struck: '🤩',
  star2: '🌟',
  stars: '🌠',
  station: '🚉',
  stats: '📊',
  statue_of_liberty: '🗽',
  steam_locomotive: '🚂',
  steamy: '🧖‍♀️',
  stethoscope: '🩺',
  stew: '🍲',
  stone: '🗿',
  stop: '🙅‍♀️',
  stop_button: '⏹️',
  stop_sign: '🛑',
  stopwatch: '⏱️',
  straight_ruler: '📏',
  strawberry: '🍓',
  strong: '💪',
  struggling: '😣',
  stuck_out_tongue: '😛',
  stuck_out_tongue_closed_eyes: '😝',
  stuck_out_tongue_winking_eye: '😜',
  student: '🧑‍🎓',
  studio_microphone: '🎙️',
  stuffed_flatbread: '🥙',
  stunned: '😧',
  subscription: '💳',
  sudan: '🇸🇩',
  summer: '🌞',
  sun_behind_large_cloud: '🌥️',
  sun_behind_rain_cloud: '🌦️',
  sun_behind_small_cloud: '🌤️',
  sun_with_face: '🌞',
  sunflower: '🌻',
  sunglasses: '😎',
  sunny: '☀️',
  sunrise: '🌅',
  sunrise_over_mountains: '🌄',
  superhero: '🦸',
  superhero_man: '🦸‍♂️',
  superhero_woman: '🦸‍♀️',
  supervillain: '🦹',
  supervillain_man: '🦹‍♂️',
  supervillain_woman: '🦹‍♀️',
  surfer: '🏄',
  surfing_man: '🏄‍♂️',
  surfing_woman: '🏄‍♀️',
  suriname: '🇸🇷',
  surprise: '😮',
  sushi: '🍣',
  suspension_railway: '🚟',
  suspicious: '🤨',
  svalbard_jan_mayen: '🇸🇯',
  swan: '🦢',
  swaziland: '🇸🇿',
  sweat: '😓',
  sweat_drops: '💦',
  sweat_smile: '😅',
  sweating: '🥵',
  sweden: '🇸🇪',
  sweet: '🍬',
  sweet_potato: '🍠',
  swim_brief: '🩲',
  swimmer: '🏊',
  swimming_man: '🏊‍♂️',
  swimming_woman: '🏊‍♀️',
  swirl: '🌀',
  switzerland: '🇨🇭',
  symbols: '🔣',
  synagogue: '🕍',
  sync: '🔄',
  syria: '🇸🇾',
  syringe: '💉',
  't-rex': '🦖',
  taco: '🌮',
  tada: '🎉',
  tag: '🏷️',
  taiwan: '🇹🇼',
  tajikistan: '🇹🇯',
  takeout_box: '🥡',
  tamale: '🫔',
  tanabata_tree: '🎋',
  tangerine: '🍊',
  tanzania: '🇹🇿',
  target: '🎯',
  taste: '👅',
  taurus: '♉',
  taxi: '🚕',
  tea: '🍵',
  teacher: '🧑‍🏫',
  team: '👥',
  teapot: '🫖',
  tear: '😿',
  tears: '🥹',
  technologist: '🧑‍💻',
  teddy_bear: '🧸',
  telephone: '☎️',
  telephone_receiver: '📞',
  telescope: '🔭',
  tempura: '🍤',
  tennis: '🎾',
  tent: '⛺',
  test_tube: '🧪',
  thailand: '🇹🇭',
  thanks: '🙇‍♀️',
  thanksgiving: '🦃',
  theater: '🎭',
  thermometer: '🌡️',
  thinking: '💭',
  thong_sandal: '🩴',
  thought_balloon: '💭',
  thread: '🧵',
  three: '3️⃣',
  thumbsdown: '👎',
  thumbsup: '👍',
  thunder: '⚡',
  ticket: '🎫',
  tickets: '🎟️',
  tiger: '🐯',
  tiger2: '🐅',
  time: '⌚',
  timer_clock: '⏲️',
  timor_leste: '🇹🇱',
  tipping_hand_man: '💁‍♂️',
  tipping_hand_person: '💁',
  tipping_hand_woman: '💁‍♀️',
  tired: '😩',
  tired_face: '😫',
  tm: '™️',
  toast: '🥂',
  togo: '🇹🇬',
  toilet: '🚾',
  tokelau: '🇹🇰',
  tokyo_tower: '🗼',
  tomato: '🍅',
  tonga: '🇹🇴',
  tongue: '👅',
  tool: '🔧',
  toolbox: '🧰',
  tooth: '🦷',
  toothbrush: '🪥',
  top: '🔝',
  tophat: '🎩',
  tornado: '🌪️',
  tr: '🇹🇷',
  trackball: '🖲️',
  tracks: '👣',
  tractor: '🚜',
  trademark: '™️',
  traffic_light: '🚥',
  train: '🚋',
  train2: '🚆',
  tram: '🚊',
  transgender_flag: '🏳️‍⚧️',
  transgender_symbol: '⚧️',
  trash: '🗑️',
  travel: '🗺️',
  triangular_flag_on_post: '🚩',
  triangular_ruler: '📐',
  trident: '🔱',
  trinidad_tobago: '🇹🇹',
  tristan_da_cunha: '🇹🇦',
  triumph: '😤',
  troll: '🧌',
  trolleybus: '🚎',
  trophy: '🏆',
  tropical_drink: '🍹',
  tropical_fish: '🐠',
  truck: '🚚',
  trumpet: '🎺',
  tshirt: '👕',
  tulip: '🌷',
  tumbler_glass: '🥃',
  tunisia: '🇹🇳',
  turkey: '🇹🇷',
  turkmenistan: '🇹🇲',
  turks_caicos_islands: '🇹🇨',
  turtle: '🐢',
  tuvalu: '🇹🇻',
  tv: '📺',
  twisted_rightwards_arrows: '🔀',
  two: '2️⃣',
  two_hearts: '💕',
  two_men_holding_hands: '👬',
  two_women_holding_hands: '👭',
  u5272: '🈹',
  u5408: '🈴',
  u55b6: '🈺',
  u6307: '🈯',
  u6708: '🈷️',
  u6709: '🈶',
  u6e80: '🈵',
  u7121: '🈚',
  u7533: '🈸',
  u7981: '🈲',
  u7a7a: '🈳',
  ufo: '🛸',
  uganda: '🇺🇬',
  uk: '🇬🇧',
  ukraine: '🇺🇦',
  umbrella: '☔',
  unamused: '😒',
  underage: '🔞',
  unicorn: '🦄',
  united: '🇺🇸',
  united_arab_emirates: '🇦🇪',
  united_nations: '🇺🇳',
  university: '🎓',
  unlock: '🔓',
  up: '🆙',
  upset: '😫',
  upside_down_face: '🙃',
  uruguay: '🇺🇾',
  us: '🇺🇸',
  us_outlying_islands: '🇺🇲',
  us_virgin_islands: '🇻🇮',
  user: '👤',
  users: '👥',
  uzbekistan: '🇺🇿',
  v: '✌️',
  vacation: '🍹',
  vampire: '🧛',
  vampire_man: '🧛‍♂️',
  vampire_woman: '🧛‍♀️',
  vanuatu: '🇻🇺',
  vatican_city: '🇻🇦',
  venezuela: '🇻🇪',
  vertical_traffic_light: '🚦',
  vhs: '📼',
  vibration_mode: '📳',
  victory: '✌️',
  video: '🎥',
  video_camera: '📹',
  video_game: '🎮',
  vietnam: '🇻🇳',
  violin: '🎻',
  virgo: '♍',
  volcano: '🌋',
  volleyball: '🏐',
  volume: '🔕',
  vomiting_face: '🤮',
  vs: '🆚',
  vulcan_salute: '🖖',
  wacky: '🤪',
  waffle: '🧇',
  wales: '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  walking: '🚶',
  walking_man: '🚶‍♂️',
  walking_woman: '🚶‍♀️',
  wallis_futuna: '🇼🇫',
  waning_crescent_moon: '🌘',
  waning_gibbous_moon: '🌖',
  warning: '⚠️',
  wastebasket: '🗑️',
  watch: '⌚',
  water: '💧',
  water_buffalo: '🐃',
  water_polo: '🤽',
  watermelon: '🍉',
  wave: '👋',
  wavy_dash: '〰️',
  waxing_crescent_moon: '🌒',
  waxing_gibbous_moon: '🌔',
  wc: '🚾',
  weapon: '🔫',
  weary: '😩',
  weather: '❄️',
  wedding: '💍',
  weight_lifting: '🏋️',
  weight_lifting_man: '🏋️‍♂️',
  weight_lifting_woman: '🏋️‍♀️',
  western_sahara: '🇪🇭',
  whale: '🐳',
  whale2: '🐋',
  wheel: '🛞',
  wheel_of_dharma: '☸️',
  wheelchair: '♿',
  whew: '😌',
  whine: '😫',
  whisky: '🥃',
  white_check_mark: '✅',
  white_circle: '⚪',
  white_flag: '🏳️',
  white_flower: '💮',
  white_haired_man: '👨‍🦳',
  white_haired_woman: '👩‍🦳',
  white_heart: '🤍',
  white_large_square: '⬜',
  white_medium_small_square: '◽',
  white_medium_square: '◻️',
  white_small_square: '▫️',
  white_square_button: '🔳',
  whoops: '🤭',
  wifi: '🛜',
  wilted_flower: '🥀',
  wind: '💨',
  wind_chime: '🎐',
  wind_face: '🌬️',
  window: '🪟',
  wine_glass: '🍷',
  wing: '🪽',
  wink: '😉',
  winner: '🏅',
  winter: '⛄',
  wip: '⚠️',
  wireless: '🛜',
  wish: '🙏',
  wizard: '🧙‍♀️',
  wolf: '🐺',
  woman: '👩',
  woman_artist: '👩‍🎨',
  woman_astronaut: '👩‍🚀',
  woman_beard: '🧔‍♀️',
  woman_cartwheeling: '🤸‍♀️',
  woman_cook: '👩‍🍳',
  woman_dancing: '💃',
  woman_facepalming: '🤦‍♀️',
  woman_factory_worker: '👩‍🏭',
  woman_farmer: '👩‍🌾',
  woman_feeding_baby: '👩‍🍼',
  woman_firefighter: '👩‍🚒',
  woman_health_worker: '👩‍⚕️',
  woman_in_manual_wheelchair: '👩‍🦽',
  woman_in_motorized_wheelchair: '👩‍🦼',
  woman_in_tuxedo: '🤵‍♀️',
  woman_judge: '👩‍⚖️',
  woman_juggling: '🤹‍♀️',
  woman_mechanic: '👩‍🔧',
  woman_office_worker: '👩‍💼',
  woman_pilot: '👩‍✈️',
  woman_playing_handball: '🤾‍♀️',
  woman_playing_water_polo: '🤽‍♀️',
  woman_scientist: '👩‍🔬',
  woman_shrugging: '🤷‍♀️',
  woman_singer: '👩‍🎤',
  woman_student: '👩‍🎓',
  woman_teacher: '👩‍🏫',
  woman_technologist: '👩‍💻',
  woman_with_headscarf: '🧕',
  woman_with_probing_cane: '👩‍🦯',
  woman_with_turban: '👳‍♀️',
  woman_with_veil: '👰‍♀️',
  womans_clothes: '👚',
  womans_hat: '👒',
  women_wrestling: '🤼‍♀️',
  womens: '🚺',
  wood: '🪵',
  woozy_face: '🥴',
  workout: '🏋️‍♀️',
  world: '🌐',
  world_map: '🗺️',
  worm: '🪱',
  worried: '😟',
  wow: '😮',
  wrench: '🔧',
  wrestling: '🤼',
  writing_hand: '✍️',
  x: '❌',
  x_ray: '🩻',
  yarn: '🧶',
  yawning_face: '🥱',
  yellow_circle: '🟡',
  yellow_heart: '💛',
  yellow_square: '🟨',
  yemen: '🇾🇪',
  yen: '💴',
  yes: '🆗',
  yin_yang: '☯️',
  yo_yo: '🪀',
  yum: '😋',
  zambia: '🇿🇲',
  zany_face: '🤪',
  zap: '⚡',
  zebra: '🦓',
  zero: '0️⃣',
  zimbabwe: '🇿🇼',
  zipper_mouth_face: '🤐',
  zombie: '🧟',
  zombie_man: '🧟‍♂️',
  zombie_woman: '🧟‍♀️',
  zoom: '🔍',
  zzz: '💤',
};
